import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckbox = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m419-321 289-290-43-43-246 247-119-119-43 43 162 162ZM120-120v-720h720v720H120Z" })
});
export default SvgCheckbox;
